import React from 'react';
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import Rewards from '../../Components/Rewards/Rewards';
import DashboardRightSection from '../../Components/DashboardRightSection/DashboardRightSection';

function RewardsPage() {
    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <Rewards />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RewardsPage;


